import gql from 'graphql-tag';
import PaymentMethodFragment from '../fragments/PaymentMethodFragment';

export default gql`
mutation UpdatePaymentMethod (
    $id: ID!
    $name: String
    $is_active: Boolean
    $before: Int
    $after: Int
    $short_description: String
    $short_description_mpl_type: String
    $cost: Int
  ) {
    adminUpdatePaymentMethod (input: {
        id: $id,
        name: $name,
        is_active: $is_active,
        before: $before
        after: $after
        short_description: $short_description
        short_description_mpl_type: $short_description_mpl_type
        cost: $cost
    }) {
        ...PaymentMethodFragment
    }
}
${PaymentMethodFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updatePaymentMethod.ts